"use strict";

var _objectSpread = require("/codebuild/output/src2429405957/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
var _core = require("@material-ui/core");
var _helpers = require("../components/utils/helpers");
var _colors = require("./colors.config");
var _fontPloni = require("./font.ploni.config");
var _fontOpenSansHebrew = require("./font.openSansHebrew.config");
var _componentsOverrides = require("./components-overrides");
var paperBorderReset = {
  '& .MuiPickersStaticWrapper-staticWrapperRoot': {
    borderRadius: '12px'
  },
  borderRadius: '12px',
  boxShadow: 'none'
};
var theme = function theme(_ref) {
  var isFontBigger = _ref.isFontBigger,
    isHighContrast = _ref.isHighContrast;
  return (0, _core.createMuiTheme)({
    breakpoints: {
      values: {
        lg: 1280,
        md: 960,
        sm: 768,
        xl: 1920,
        xs: 0
      }
    },
    direction: 'rtl',
    overrides: {
      MuiBackdrop: _componentsOverrides.backdropStyle,
      MuiButton: (0, _componentsOverrides.buttonStyle)(isFontBigger, isHighContrast),
      MuiCheckbox: _componentsOverrides.checkboxStyle,
      MuiChip: (0, _componentsOverrides.chipStyle)(isFontBigger, isHighContrast),
      MuiCssBaseline: {
        '@global': {
          '@font-face': [_fontPloni.PloniUltralight, _fontPloni.PloniLight, _fontPloni.PloniRegular, _fontPloni.PloniMedium, _fontPloni.PloniDemibold, _fontPloni.PloniBold, _fontPloni.PloniUltrabold, _fontPloni.PloniBlack, _fontOpenSansHebrew.OpenSansHebLight, _fontOpenSansHebrew.OpenSansHebRegular, _fontOpenSansHebrew.OpenSansHebBold, _fontOpenSansHebrew.OpenSansHebBlack]
        }
      },
      MuiDialog: _componentsOverrides.modalStyle,
      MuiFab: _componentsOverrides.fabStyle,
      MuiFormControl: (0, _componentsOverrides.formControlStyle)(isFontBigger, isHighContrast),
      MuiFormControlLabel: (0, _componentsOverrides.radioStyle)(isFontBigger, isHighContrast),
      MuiFormGroup: {
        root: {
          '&[role=radiogroup]': {
            '& .MuiFormControlLabel-root:last-child': {
              marginRight: 'unset'
            }
          }
        }
      },
      MuiInputLabel: (0, _componentsOverrides.inputLabelStyle)(isFontBigger, isHighContrast),
      MuiLink: (0, _componentsOverrides.linkStyle)(isFontBigger, isHighContrast),
      MuiOutlinedInput: (0, _componentsOverrides.outlineInputStyle)(isFontBigger, isHighContrast),
      MuiPaper: {
        root: {
          '& .MuiPickersBasePicker-container': _objectSpread({}, (0, _componentsOverrides.datepickerStyle)(isFontBigger, isHighContrast)),
          '&.MuiMenu-paper': (0, _componentsOverrides.paperMenuStyle)(isFontBigger, isHighContrast),
          '&.MuiPaper-elevation8': paperBorderReset
        }
      },
      MuiSnackbarContent: (0, _componentsOverrides.snackbarContentStyle)(isFontBigger, isHighContrast),
      MuiStep: (0, _componentsOverrides.breadcrumbsStepStyle)(isHighContrast),
      MuiStepConnector: (0, _componentsOverrides.breadcrumbsStepConnectorStyle)(isHighContrast),
      MuiStepLabel: (0, _componentsOverrides.breadcrumbsStepLabelStyle)(isFontBigger, isHighContrast),
      MuiTab: (0, _componentsOverrides.tabStyle)(isFontBigger, isHighContrast),
      MuiTabs: _componentsOverrides.tabsStyle,
      MuiTextField: (0, _componentsOverrides.textFieldLabelStyle)(isFontBigger, isHighContrast),
      MuiTooltip: (0, _componentsOverrides.toolTipStyle)(isFontBigger, isHighContrast)
    },
    palette: {
      error: {
        main: isHighContrast ? _colors.Red[200] : _colors.Red[500]
      },
      primary: {
        contrastText: isHighContrast ? 'rgba(0, 0, 0, 0.75)' : '#ffffff',
        dark: isHighContrast ? _helpers.agentDeveloperUtils.getPrimaryColor(310) : _helpers.agentDeveloperUtils.getPrimaryColor(500),
        light: isHighContrast ? _helpers.agentDeveloperUtils.getPrimaryColor(290) : _helpers.agentDeveloperUtils.getPrimaryColor(440),
        main: isHighContrast ? _helpers.agentDeveloperUtils.getPrimaryColor(300) : _helpers.agentDeveloperUtils.getPrimaryColor(450)
      },
      secondary: {
        contrastText: isHighContrast ? '#000' : '#ffffff',
        dark: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(200) : _helpers.agentDeveloperUtils.getSecondaryColor(500),
        darkLight: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(195) : _helpers.agentDeveloperUtils.getSecondaryColor(500),
        light: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(50) : _helpers.agentDeveloperUtils.getSecondaryColor(200),
        main: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(100) : _helpers.agentDeveloperUtils.getSecondaryColor(300),
        mainDark: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(200) : _helpers.agentDeveloperUtils.getSecondaryColor(300),
        mainLight: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(195) : _helpers.agentDeveloperUtils.getSecondaryColor(300)
      },
      type: isHighContrast ? 'dark' : 'light'
    },
    props: {
      MuiButton: _componentsOverrides.buttonProps,
      MuiFormControl: _componentsOverrides.formControlProps,
      MuiSelect: _componentsOverrides.selectProps,
      MuiTextField: _componentsOverrides.textfieldProps
    },
    shape: {
      borderRadius: 30
    },
    typography: {
      fontFamily: ['Ploni', 'Arial', 'sans-serif'].join(','),
      fontSize: isFontBigger ? 20 : 16,
      fontWeightBold: '700',
      fontWeightLight: '300',
      fontWeightMedium: '500',
      fontWeightRegular: '400'
    }
  });
};
exports.theme = theme;